import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Col, Container, Form, Row} from "react-bootstrap";
import Button from "../Button";
import {Img} from "../Img";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {ToastContainer} from "react-toastify";
import Title from "../Title";
import {hover} from "../../styles/globalStyleVars";
import {useForm} from "react-hook-form";
// import {apiEndPoints} from "../../api/network/apiEndPoints";
// import {postForm} from "../../api/redux/career";
import reactHtmlParser from "react-html-parser";
import {gsap, TimelineLite} from "gsap";
import {ApiServices} from "../../pages/api/network/ApiServices";
import {postForm} from "../../pages/api/redux/contact";

const MyComponent = ({data, popup, bg, des, padding}) => {


    const dispatch = useDispatch()
    const formData = useSelector(state => state.careerReducer)
    const [validPosition, setValidPosition] = useState(false)
    const [uploadText, setUploadText] = useState('Attach CV')

    const DropdownOption = [
        {value: 'Front-end Developer', label: 'Front-end Developer'},
        {value: 'WordPress Developer', label: 'WordPress Developer'},
        {value: 'DevOps Developer', label: 'DevOps Developer'},

    ];


    const {
        register,
        control,
        handleSubmit,
        formState: {errors, isSubmitSuccessful},
        reset,
    } = useForm({
        mode: "all",
    });
    const store = useSelector(state => state.career);

    //--- form submit
    const success = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    const error = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    const onSubmit = async (e) => {

        let api_services = ApiServices.SUBMITFORM;

        var formData = new FormData();
        formData.append('name', e?.name);
        formData.append('email', e?.email);
        formData.append('phone', e?.phone);
        formData.append('message', e?.message);
        formData.append('form_id', 'career-form');
        formData.append('file', e?.file?.[0]);
        formData.append('spam_protector', '');


        document.querySelector('.gph_upload').classList.remove('hide')

        setUploadText('Attach CV')

        const tl = new TimelineLite()

        if (e.email !== '' && e.name !== '' && e.phone !== '') {
            await dispatch(postForm([api_services, formData]));

            reset();

        }
    };

    useEffect(() => {
        if (!store?.loading) {
            if (isSubmitSuccessful) {
                success("Thank you for your message");
                reset();
            }
        }
    }, [isSubmitSuccessful, store]);

    let count = 0;

    const onError = (errors) => {
        Object.values(errors).forEach((error) => {
            count++;
        });
        if (count > 0) {
            toast.error("Fill out the correct inputs");
        }
        count = 0;
    };

    // let count = 0;
    // const onError = (errors) => {
    //     Object.values(errors).forEach((error) => {
    //         count++;
    //     });
    //     if (count > 0) {
    //         toast.error('Fill out the correct inputs');
    //     }
    //     count = 0;
    // };
    // useEffect(() => {
    //     if (responseData && responseData?.error !== '') {
    //         error(responseData?.error?.message)
    //     }
    //     if (responseData && responseData?.success !== '') {
    //         success(responseData?.success)
    //         // gsap.registerPlugin(ScrollTrigger);
    //         // reset()
    //
    //         // ScrollTrigger.refresh();
    //     }
    //     reset()
    // }, [responseData])


    const handleDropdown = (e) => {
        // e.value;
        setValidPosition(e?.label)
    }

// handleUpload function
    function handleUpload(event) {
        const selectedFile = event.target.files[0];

        if (selectedFile) {
            const fileName = selectedFile.name;
            setUploadText(fileName)
            document.querySelector('.gph_upload').classList.add('hidden');

        }

    }


    return (
        <StyledComponent bg={bg}>
            <ToastContainer position="top-right" autoClose={4000} closeOnClick hideProgressBar={true}/>

            <div className={`career_form  ${padding ? padding : 'pb-200'}`}>
                <Container>
                    <Row>
                        {
                            popup ?

                                <Col md={{span: 5}} className="popup popup_data">
                                    {
                                        des &&
                                        reactHtmlParser(des)
                                    }

                                </Col>
                                :

                                <Col md={{span: 5}}>
                                    <div className="image_wrapper">
                                        {
                                            data?.images?.list?.[0]?.full_path &&
                                            <Img alt={'Shanta Securities Limited'}
                                                 src={data?.images?.list?.[0]?.full_path}/>

                                        }
                                    </div>
                                    {
                                        data?.section_data?.short_desc &&
                                        <Title noanim margin={'40px 0 0 0'} text={data?.section_data?.short_desc}/>

                                    }

                                </Col>
                        }


                        <Col md={{span: 6, offset: 1}} className="formContact">
                            <div className="form-wrapper-all">
                                <Form onSubmit={handleSubmit(onSubmit, onError)} method="post"
                                      enctype="multipart/form-data">
                                    <Row>
                                        <input name={'spam_protector'} type='hidden'/>
                                        <input name={'form_id'} value={'career-form'} type='hidden'/>

                                        <Form.Group className="col-md-12 pb-30">

                                            <Form.Control
                                                className={errors?.name?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                                {...register("name", {
                                                    required: 'Name is required',
                                                    pattern: {
                                                        message: 'Name must contain only letters',
                                                    },

                                                })}
                                                type="text"
                                                placeholder="First Name*"
                                            />
                                        </Form.Group>
                                        <Form.Group className="col-md-12 pb-30">
                                            <Form.Control
                                                className={errors?.email?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                                {...register("email", {
                                                    required: {
                                                        value: true,
                                                        message: 'Email is required'
                                                    },
                                                    pattern: {
                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                        message: 'Enter a Valid Email'
                                                    }
                                                })}
                                                type="email"
                                                placeholder="Email*"/>
                                        </Form.Group>
                                        <Form.Group className="col-md-12 pb-30">
                                            <Form.Control
                                                className={errors?.phone?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                                {...register("phone", {
                                                    required: {
                                                        value: true,
                                                        message: 'Phone is required'
                                                    },
                                                    pattern: {
                                                        value: /^01[0-9]{9}$/,
                                                        message: 'Enter a valid 11 digit phone number'
                                                    }
                                                })}
                                                type="number"
                                                placeholder="Phone Number*"/>
                                        </Form.Group>
                                        <div className="clear"></div>
                                        {/*<Form.Group className="col-md-12 pb-30">*/}
                                        {/*    <Select*/}

                                        {/*        placeholder={'Preferred Position *'}*/}

                                        {/*        styles={{*/}
                                        {/*            dropdownIndicator: (provided, state) => ({*/}
                                        {/*                ...provided,*/}
                                        {/*                transform: state.selectProps.menuIsOpen && "rotate(180deg)"*/}
                                        {/*            })*/}
                                        {/*        }}*/}
                                        {/*        onChange={handleDropdown}*/}
                                        {/*        classNamePrefix={'react-select'}*/}
                                        {/*        className={'form-select'}*/}
                                        {/*        options={DropdownOption}*/}
                                        {/*        theme={(theme) => ({*/}
                                        {/*            ...theme,*/}
                                        {/*            borderRadius: 0,*/}
                                        {/*            colors: {*/}
                                        {/*                ...theme.colors,*/}
                                        {/*                primary25: '#e9e9e9',*/}
                                        {/*                primary: 'black',*/}
                                        {/*            },*/}
                                        {/*        })}*/}

                                        {/*    />*/}


                                        {/*</Form.Group>*/}

                                        <Form.Group className="col-md-12 pb-30">
                                            <Form.Control
                                                className={ 'form-control-lg'}
                                                {...register("message", {
                                                    required: {
                                                        // value:true,
                                                        message: 'Message is Required'
                                                    },

                                                })}
                                                type="text"
                                                placeholder="Cover Letter"/>

                                        </Form.Group>
                                        <Form.Group className="col-xl-6 pb-30">


                                            <Form.Control
                                                onInput={handleUpload}
                                                className={'gph_upload'}
                                                text={uploadText}
                                                type="file"
                                                accept=".pdf"
                                                {...register('file')}
                                            />
                                        </Form.Group>

                                        <Form.Group className="col-xl-6 widthHalf"
                                                    onClick={handleSubmit(onSubmit, onError)}>
                                            <Button padding={'0'} color={'white'} hoverColor={'#3C3C3B'} hoverBackground={'#FFFFFF'}
                                                    width={'auto'} text={'Submit Application'} classname={'col-md-6'}/>
                                        </Form.Group>

                                    </Row>
                                </Form>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
    background: ${props => props.bg ? props.bg : '#f2f2f2'};

    .image_wrapper {
        position: relative;
        padding-top: calc(244 / 500 * 100%);
    }

    .dc-btn a{
        &:hover{
            color: white !important;
        }
    }
    .form-wrapper-all {
        background: #3c3c3b;
        padding: 60px 70px;
        @media (max-width: 992px) {
            padding: 60px 30px;
        }
        @media (max-width: 767px) {
            padding: 60px 15px;
        }
    }

    .form-control {
        margin-bottom: 30px;
        background: transparent;
        border-left: none;
        border-right: none;
        border-top: none;
        border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    }

    .dc-btn {
        width: 100%;

        a {
            justify-content: center !important;
        }
    }

    .formContact {
        label {
            font-size: 12px;
            line-height: 18px;
            font-weight: 300;
        }

        input {
            &:not(.react-select__input input) {
                line-height: 20px;
                border-radius: 0;
                height: 44px;
                border-color: rgba(255, 255, 255, 0.5);
            }

            padding-left: 0;
            padding-right: 0;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            color: #FFFFFF;

            &::placeholder {
                font-size: 16px;
                font-weight: 500;
                line-height: 24px;
                color: rgba(255, 255, 255, 0.5);

            }
        }

        .react-select__menu {
            z-index: 9;
        }

        .react-select__control--menu-is-open {

        }

        .react-select__indicators {
            display: block;

            .react-select__indicator {
                padding-right: 0;
                padding-left: 0;
                color: white !important;
            }
        }

        .react-select__value-container {
            padding: 0;
            display: block;
        }

        .react-select__single-value {
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            color: rgba(255, 255, 255, 1);
        }

        textarea {
            border-radius: 0;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            color: #FFFFFF;
            padding-left: 0;
            padding-right: 0;
            border-color: rgba(255, 255, 255, 0.5);

            &::placeholder {
                font-size: 16px;
                font-weight: 500;
                line-height: 24px;
                color: rgba(255, 255, 255, 0.5);
            }
        }

        .form-select {
            .react-select__indicator-separator {
                display: none;
            }

            .react-select__control {
                //height: 48px;
                border-color: rgba(255, 255, 255, 0.5);
                box-shadow: none;
                border-left: none;
                border-top: none;
                border-right: none;
                background: transparent;
                height: 30px;
                margin-bottom: 40px;
            }

            .react-select__placeholder {
                font-size: 16px;
                font-weight: 500;
                line-height: 24px;
                color: rgba(255, 255, 255, 0.5);
            }
        }

        .dc-btn {
            a {
                justify-content: center;

                span {
                    //margin-right: 15px;
                }

                svg {
                    //margin-left: 15px;
                }
            }
        }
    }

    .max_size {
        font-size: 10px;
        font-weight: 300;
        line-height: 20px;
        color: rgba(34, 34, 34, 0.8);
        margin: 5px 0 0;
    }

    .gph_upload {
        position: relative;
        cursor: pointer;
        border: none !important;
        border-radius: 25px !important;
        overflow: hidden !important;

        &.hidden {
            &:before {
                opacity: 0;
            }
        }

        &:after {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            content: attr(text);
            border: 1px #FFFFFF;
            border-radius: 25px;
            border-style: dashed;
            background: #3C3C3B;
            z-index: 1;
            font-size: 16px;
            line-height: 24px;
            font-weight: 500;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: 0.7s all ease;
            padding-left: 20px;
        }

        &:before {
            content: '';
            background-image: url('images/static/attach.svg');
            width: 20px;
            height: 20px;
            background-repeat: no-repeat;
            background-size: contain;
            position: absolute;
            z-index: 11;
            left: 25%;
            top: 10px;
        }

        @media (min-width: 1024px) and (max-width: 1280px) {
            &:after {
                padding-left: 20px;
            }

            &:before {
                left: 23%;
            }
        }
        @media (min-width: 1536px) {
            &:before {
                left: 30%;
            }
        }

        &:hover {
            &:after {
                border: 1px ${hover};
                border-radius: 25px;
                background: ${hover};
            }
        }
    }

    .has-error {
        border-color: #EE1B24 !important;
    }

    @media (min-width: 1550px) {
        .widthHalf {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
    input:-webkit-autofill{
        -webkit-text-fill-color: #fff;
    }
`;

export default MyComponent;